/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_imprint.js                                                                            */
/**********************************************************************************************************************/
/* Controller.Custom */
HafasWebapp.prototype.Controller.Imprint = {
  currentOverlay: null,
  index: function (data) {
    var _me = this;

    // show imprint in Overlay (project_src/standard)
    var _outputHtml = '',
      model = {};

    if (Hafas.Modules.History)
      Hafas.Modules.History.addData("Imprint", "index", {});

    Hafas.Modules.Render.render(
      {
        file: 'imprint.index.html',
        template: 'Imprint_Index',
        model: model
      },
      function (html) {

        // minify output-HTML for overlay
        _outputHtml = html.replace(/\n/g, '');

        _me.Controller.Imprint.currentOverlay = Hafas.Core.newType("HafasOverlay", {
          app: _me,
          outputHTML: _outputHtml,
          title: Hafas.Modules.i18n.get('Imprint.t_N_Imprint'),
          cssClass: 'hfs_overlayImprint',
          onClose: Hafas.bind(_me.Controller.Imprint.onCloseOverlay, _me)
        });

        // Track
        Hafas.ps.pub('/tracking/screen/imprint-main');
      });


    if (Hafas.Config.layoutMode === '_classic') {
      Hafas.Modules.Render.render(
        {
          file: 'imprint.index.html',
          target: _me.formContainer,
          template: 'Imprint_Index',
          model: {
            returnToContext: _me.prevContext,
            cbOnClose: Hafas.bind(_me.Controller.Imprint.onCloseOverlay, _me)
          }
        },
        function (html) {


        }
      );
    }
  },
  onCloseOverlay: function () {
    Hafas.ps.pub("/GUI/common/back", []);
    this.Controller.Imprint.currentOverlay = null;
  },
  closeView: function () {
    // console.log("close Imprint", this.Controller.Imprint.currentOverlay);
    if (this.Controller.Imprint.currentOverlay != null)
      this.Controller.Imprint.currentOverlay.close();
    this.Controller.Imprint.currentOverlay = null;
  },
  restoreView: function () {
    Hafas.bind(this.Controller.Imprint.index, this)();
  }
};
